/** QuickRouter — Barre d'état : message courant, sélection, raccourcis. */
import { useProjectStore } from '../store/useProjectStore.js';

export default function StatusBar() {
  const statusText = useProjectStore((s) => s.statusText);
  const selection = useProjectStore((s) => s.selection);
  const me = useProjectStore((s) => s.me);
  return (
    <div className="statusbar">
      <span className="grow">{statusText}</span>
      {selection.length > 0 && <span>{selection.length} sélectionné{selection.length > 1 ? 's' : ''}</span>}
      <span className="keys">glisser déplacer (Alt libre) · R tourner · F retourner · X piste · V couche · molette zoom · clic droit vue · Suppr</span>
      {me?.version && <span className="ver">v{me.version}</span>}
    </div>
  );
}
